const normalizeName = (name) => String(name || "").toLowerCase().replace(/\s+/g, " ").trim();
const normalizeNumber = (number) => String(number ?? "").trim().replace(/^0+(?=\d)/, "");

function identity(label) {
  const text = String(label || "").trim();
  const numbered = text.match(/^(\d+)\s*\.\s*(.*)$/);
  return numbered
    ? { number: normalizeNumber(numbered[1]), name: normalizeName(numbered[2]) }
    : { number: /^\d+$/.test(text) ? normalizeNumber(text) : "", name: /^\d+$/.test(text) ? "" : normalizeName(text) };
}

function buildPrices(lines) {
  if (!Array.isArray(lines)) return [];
  return lines.flatMap((line) => {
    if (typeof line !== "string") return [];
    const split = line.lastIndexOf(":");
    if (split < 0) return [];
    const price = Number(line.slice(split + 1).trim());
    if (!Number.isFinite(price) || price <= 0) return [];
    return [{ ...identity(line.slice(0, split)), price }];
  });
}

function matchingPrice(horse, prices) {
  const derived = identity(horse.formattedName);
  const name = normalizeName(horse.name) || derived.name;
  const number = normalizeNumber(horse.number) || derived.number;
  // Generated lists can disagree about runner numbers. A named tip must never
  // inherit the price of a different horse just because its number matches.
  const matches = prices.filter((entry) => name
    ? entry.name === name
    : number && entry.number === number);
  const uniquePrices = new Set(matches.map((entry) => entry.price));
  return uniquePrices.size === 1 ? matches[0].price : null;
}

export function enrichFirstFourWithOdds(race) {
  if (!race || !Array.isArray(race.firstFourData)) return race;
  const calculated = buildPrices(race.calculatedOdds);
  const book = buildPrices(race.book);
  return {
    ...race,
    firstFourData: race.firstFourData.map((horse) => {
      if (!horse || typeof horse !== "object") return horse;
      const price = matchingPrice(horse, calculated) ?? matchingPrice(horse, book);
      return price === null ? horse : { ...horse, currentPrice: price };
    }),
  };
}
